import React from 'react';

import { BasicCategoryItem } from '@/components/NavigationContent/types';

import styles from './Block.module.scss';

interface BlockCategoryPropTypes {
  items: BasicCategoryItem[];
  handleItemClick: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>,
    item: BasicCategoryItem
  ) => void;
}

const Block: React.FC<BlockCategoryPropTypes> = ({
  items,
  handleItemClick,
}) => {
  if (!items || !items.length) return null;

  const getItemHref = (item: BasicCategoryItem) => {
    if (item.route_link) return item.route_link;
    return item.url ? (item.url.includes('javascript') ? '#' : item.url) : '';
  };

  const handleBlockItemClick = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>,
    item: BasicCategoryItem
  ) => {
    const { url } = item;

    if (url && url.includes('usabilla')) {
      try {
        event.preventDefault();
        window.usabilla_live('click');
      } catch (e) {
        console.error('Could not open feedback item from the mobile menu.');
      }
    } else {
      handleItemClick(event, item);
    }
  };

  return (
    <div data-testid="block-wrapper" className={styles.itemsWrapper}>
      {items.map((item, index) => (
        <a
          className={styles.item}
          key={index}
          data-testid="block-item"
          onClick={e => handleBlockItemClick(e, item)}
          href={getItemHref(item)}
          target={item.target || ''}
          rel={`${item.notIndexed ? 'nofollow' : ''}`}
        >
          <img
            data-testid="image"
            className={styles.icon}
            src={item.image?.source || ''}
            alt={item.image_alt_text || ''}
          />
          <span className={styles.title}>{item.title}</span>
        </a>
      ))}
    </div>
  );
};

export default Block;
